
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frequently-asked-questions",
      function () {
        return require("private-next-pages/frequently-asked-questions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frequently-asked-questions"])
      });
    }
  